var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Bond日志",
            visible: _vm.visible,
            width: "900px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "bond-no-info" }, [
            _vm._v("当前查询Bond：" + _vm._s(_vm.currentBondNo))
          ]),
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeTab,
                callback: function($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab"
              }
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "续保记录", name: "renewal" } },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.renewalRecords, border: "" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "原到期日期", width: "120" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDate(scope.row.originalExpiryDate)
                                  )
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { label: "更新后到期日期", width: "130" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDate(scope.row.newExpiryDate)
                                  )
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "operator",
                          label: "操作人",
                          width: "100"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "operateTime",
                          label: "操作时间",
                          width: "160"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "renewalDesc",
                          label: "修订备注 (续保说明)",
                          "show-overflow-tooltip": ""
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "修订记录", name: "revision" } },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.revisionRecords, border: "" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "operateType",
                          label: "操作类型",
                          width: "100"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "operator",
                          label: "操作人",
                          width: "100"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "operateTime",
                          label: "操作时间",
                          width: "160"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "changeField",
                          label: "变更字段",
                          width: "140"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "变更内容 (原值 -> 新值)",
                          width: "280"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.operateType === "编辑修改"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "change-content-link",
                                        on: {
                                          click: function($event) {
                                            return _vm.showChangeDetail(
                                              scope.row.changeContent
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.truncateContent(
                                              scope.row.changeContent
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      { staticClass: "change-content-text" },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row.changeContent || "-")
                                        )
                                      ]
                                    )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("关闭")
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "变更详情",
            visible: _vm.detailVisible,
            width: "500px",
            "append-to-body": "",
            "close-on-click-modal": false,
            "custom-class": "bond-change-detail-dialog"
          },
          on: {
            "update:visible": function($event) {
              _vm.detailVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "change-detail-list" },
            _vm._l(_vm.changeDetailList, function(item, index) {
              return _c(
                "div",
                { key: index, staticClass: "change-detail-item" },
                [
                  _c("span", { staticClass: "field-name" }, [
                    _vm._v(_vm._s(item.field))
                  ]),
                  _c("span", { staticClass: "arrow" }, [_vm._v("->")]),
                  _c("span", { staticClass: "old-value" }, [
                    _vm._v(_vm._s(item.oldValue))
                  ]),
                  _c("span", { staticClass: "new-value" }, [
                    _vm._v(_vm._s(item.newValue))
                  ])
                ]
              )
            }),
            0
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.detailVisible = false
                    }
                  }
                },
                [_vm._v("关闭")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }